var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row align-center"},[_c('v-overflow-btn',{attrs:{"items":_vm.type_items,"dense":"","hide-details":""},model:{value:(_vm.taxType),callback:function ($$v) {_vm.taxType=$$v},expression:"taxType"}}),_c('v-spacer'),_c('Create')],1),_c('List',{attrs:{"products":_vm.selectedProducts}}),_c('EditForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }